import { render, staticRenderFns } from "./y-player.vue?vue&type=template&id=ea8a7b90"
import script from "./y-player.vue?vue&type=script&lang=js"
export * from "./y-player.vue?vue&type=script&lang=js"
import style0 from "./y-player.vue?vue&type=style&index=0&id=ea8a7b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports